<template>
  <div class="contactlist">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">工程联系单配置</span>
      </div>
      <!-- 这里是内容 -->
      <el-row v-loading="loading">
        <el-col :span="12">
          <div class="h400-overflow-auto">
            <el-card shadow="never">
              <!-- 这里是审批流程 -->
              <div slot="header">
                <h2>审批流程</h2>
              </div>
              <div>
                <el-button
                  type="primary"
                  class="width100-mar"
                  @click="approvalOpen"
                  >添加</el-button
                >
                <div class="mar-bot10">
                  <el-row v-for="(item, index) in approvalList" :key="index">
                    <el-col :span="5">
                      <el-select
                        filterable
                        v-model="item.Type"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item2, index2) in options"
                          :key="index2"
                          :label="item2.label"
                          :value="item2.value"
                          @click.native="changeshenp(item, item2)"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="13" :offset="1">
                      <el-row>
                        <el-col
                          :span="8"
                          class="mar-bot10"
                          v-for="(item2, index2) in item.Aus"
                          :key="index2"
                        >
                          <div class="mar0a-w42">
                            <img
                              width="42px"
                              height="42px"
                              :src="$store.state.baseUrl + item2.image"
                            />
                          </div>
                          <p class="text-one">{{ item2.Name }}</p>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="4" :offset="1">
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        @click="delAtta(item)"
                      ></el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="12">
          <!-- 这里是抄送流程 -->
          <div class="cslc">
            <el-card shadow="never">
              <div slot="header">
                <h2>抄送流程</h2>
              </div>
              <div>
                <el-button
                  type="primary"
                  class="w100-mar"
                  @click="copyProcessOpen"
                  >添加</el-button
                >
                <el-row>
                  <el-col
                    class="mar-bot10"
                    :span="4"
                    v-for="(item, index) in copyProcessList.Aus"
                    :key="index"
                  >
                    <div class="mar-pos">
                      <img
                        width="42px"
                        height="42px"
                        :src="$store.state.baseUrl + item.image"
                      />
                      <div @click="delAttaUser(item)" class="box-one">X</div>
                    </div>
                    <p class="box-tow">{{ item.Name }}</p>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog :close-on-click-modal = "false"
      title="添加审批流程"
      :visible.sync="approval"
      width="30%"
      :before-close="handleClose2"
    >
      <span>添加审批流程</span>
      <el-table
        ref="multipleTable"
        :data="ProjectUserList"
        tooltip-effect="dark"
        class="width100"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="user04"
          label="同户名"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="user11"
          label="手机号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="user12"
          label="邮箱"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-select filterable v-model="value2" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" v-if="btnShow" @click="addapproval"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal = "false"
      title="添加抄送流程"
      :visible.sync="copyProcess"
      width="30%"
      :before-close="handleClose"
    >
      <span>添加抄送流程</span>
      <el-table
        ref="multipleTable"
        :data="ProjectUserList"
        tooltip-effect="dark"
        class="width100"
        @selection-change="handleSelectionChange2"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="user04"
          label="同户名"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="user11"
          label="手机号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="user12"
          label="邮箱"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="btnShow2" @click="addCopyProcess"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetLabelList,
  AddLabelList,
  RemoveLabelListss,
  UpdateLabelListss,
  GetDesignUser,
  GetMember,
  GetAuditUserList,
  AddAuditUser,
  AddCCUser,
  UpdatePworkFlow,
  GetLablesetListOpen,
  delAtta,
  delAttaUser
} from "@/setAxios.js";
export default {
  name: "contactlist",
  data() {
    return {
      btnShow: true,
      btnShow2: true,
      // 审批
      approval: false,
      // 抄送
      copyProcess: false,
      // 审批流程
      approvalList: [],
      // 抄送流程
      copyProcessList: [],
      ProjectUserList: [],
      multipleSelection: [],
      multipleSelection2: [],
      approvalListLength: 0,
      copyProcessListLength: "",
      options: [
        {
          value: 1,
          label: "或签"
        },
        {
          value: 2,
          label: "会签"
        }
      ],
      value2: "",
      majorName: "",
      rank: "",
      // 是否启用
      startUsing: true,
      loading: false
    };
  },
  methods: {
    delAttaUser(data) {
      //(data);
      let params = {
        xid: localStorage.getItem("xid"),
        uid: data.Uid,
        type: 2
      };
      delAttaUser(params).then(res => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功"
          });
          this.getData();
        }
      });
    },
    // 删除审批流程
    delAtta(row) {
      //(row);
      let params = {
        id: row.id
      };
      delAtta(params).then(res => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功"
          });
          this.getData();
        }
      });
    },
    // 修改或签会签

    changeshenp(data1, data2) {
      //(data1, data2);
      let params = {
        type: data2.value,
        flowid: data1.Aus[0].GroupType
      };
      UpdatePworkFlow({ ...params }).then(res => {
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: "修改成功"
          });
          this.getData();
        }
      });
    },
    addapproval() {
      if (this.value2 == "") {
        this.$message({
          type: "warning",
          message: "请选择类型"
        });
      } else {
        if (this.multipleSelection.length > 0) {
          this.btnShow = false;
          let uid = [];
          this.multipleSelection.forEach(ele => {
            uid.push(ele.user01);
          });
          let params = {
            WorkType: this.value2,
            Uids: uid,
            Order: this.approvalListLength + 1,
            Xid: localStorage.getItem("xid"),
            WorkFlowType: 2
          };
          AddAuditUser({ model: JSON.stringify(params) }).then(res => {
            if (res.Code > 0) {
              //(res, "添加审批流程");
              this.$message({
                type: "success",
                message: "添加成功"
              });
              this.approval = false;
              this.getData();
              this.multipleSelection = [];
            }
          });
        } else {
          this.$message({
            type: "warning",
            message: "请先选择审批人"
          });
        }
      }
    },
    addCopyProcess() {
      if (this.multipleSelection2.length > 0) {
        this.btnShow2 = false;
        let uid = [];
        this.multipleSelection2.forEach(ele => {
          uid.push(ele.user01);
        });
        let params = {
          WorkType: 1,
          Uids: uid,
          Order: this.copyProcessListLength + 1,
          Xid: localStorage.getItem("xid"),
          WorkFlowType: 2
        };
        AddCCUser({ model: JSON.stringify(params) }).then(res => {
          if (res.Code > 0) {
            //(res, "添加审批流程");
            this.$message({
              type: "success",
              message: "添加成功"
            });
            this.copyProcess = false;
            this.getData();
            this.multipleSelection2 = [];
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "请先选择审批人"
        });
      }
    },
    approvalOpen() {
      this.btnShow = true;
      this.approval = true;
      let params = {
        xid: localStorage.getItem("xid"),
        type: 2
      };
      GetAuditUserList({ params }).then(res => {
        this.ProjectUserList = res.Data;
        //(res, "人员");
      });
    },
    copyProcessOpen() {
      this.btnShow2 = true;
      this.copyProcess = true;
      let params = {
        xid: localStorage.getItem("xid"),
        type: 2
      };
      GetAuditUserList({ params }).then(res => {
        this.ProjectUserList = res.Data;
        //(res, "人员");
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      //(this.multipleSelection);
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
      //(this.multipleSelection2);
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleClose2(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    // 获取所有数据
    getData() {
      var params = {
        xid: localStorage.getItem("xid"),
        type: 2
      };
      GetDesignUser({ params }).then(res => {
        //(res, "工程联系单");
        if (res.Data.length > 0) {
          if (res.Data[0].OrderNum == 0 || res.Data.Type == "") {
            this.copyProcessList = res.Data[0];
            if (res.Data.length > 1) {
              this.approvalList = res.Data.slice(1);
              this.approvalListLength = this.approvalList[
                this.approvalList.length - 1
              ].Aus[0].GroupType;
            } else {
              this.approvalList = [];
            }
          } else {
            this.copyProcessList = [];
            this.approvalList = res.Data;
            this.approvalListLength = this.approvalList[
              this.approvalList.length - 1
            ].Aus[0].GroupType;
          }
        } else {
          this.approvalList = [];
          this.copyProcessList = [];
          //("无数据");
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="less"></style>
<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}
.h400-overflow-auto {
  height: 400px;
  overflow: auto;
}
.width100-mar {
  width: 100%;
  margin: 26px 0 20px;
}
.mar-bot10 {
  margin-bottom: 10px;
}
.mar0a-w42 {
  margin: 0 auto;
  width: 42px;
}
.text-one {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 58px;
  margin: 0 auto;
}
.cslc {
  height: 340px;
  overflow: auto;
  margin-left: 10px;
}
.w100-mar {
  width: 100%;
  margin: 26px 0 20px;
}
.mar-pos {
  margin: 0 auto;
  width: 42px;
  position: relative;
}
.box-one {
  background: red;
  color: #fff;
  width: 15px;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  top: -6px;
  right: -6px;
}
.box-tow {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 58px;
  margin: 0 auto;
}
.width100 {
  width: 100%;
}
</style>
